import { render } from "./TranslationInput.vue?vue&type=template&id=31154d56&scoped=true"
import script from "./TranslationInput.vue?vue&type=script&lang=js"
export * from "./TranslationInput.vue?vue&type=script&lang=js"

import "./TranslationInput.vue?vue&type=style&index=0&id=31154d56&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-31154d56"

export default script